import { ApiKey, ApiPathManager, ServiceCode } from "app/shared/services/api-path";
import { instance } from "app/shared/util/token-store";
import { FetchChangePasswordAuthRequest } from "../reducer/types";
import store from "app/shared/store/store";
import { REQUESTINPUT } from "app/shared/services/services-model.type";

const authParam = (action?: FetchChangePasswordAuthRequest) => {
  const userProfileKeyCloak = store.getState().auth.userProfile;
  const dataForm = store.getState().changePassword.dataForm;
  const params: REQUESTINPUT = {
    AUTHORIZE_CODE: action?.code,
    CHALLENGE_ID: action?.payload?.CHALLENGE_ID,
    USERPROFILE: {
      USERIDUPDATE: userProfileKeyCloak?.username,
      USERPASSWORD: dataForm?.passwordCurrent,
      NEWPASSWORD: dataForm?.passwordNew,
      USERGROUPTYPE: dataForm?.isPVConnect ? "PVCONNECT" : "NORMAL", // PVCONNECT, NORMAL,
    },
    TRANSFER: {
      RQSTSEQ: action?.payload?.TRANSFER?.RQSTSEQ || "",
    },
  };
  return params;
};

export const fetchChangePasswordService = async () => {
  const { url } = ApiPathManager(ApiKey.CHANGE_PASSWORD);
  const body = {};
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchChangePasswordAuthService = async (actionRq: FetchChangePasswordAuthRequest) => {
  const { url } = ApiPathManager(ApiKey.CHANGE_PASSWORD_AUTHORIZATION);
  const requestInput = authParam(actionRq);
  const body = {
    REQUESTINPUT: requestInput,
  };
  const response: any = await instance.post(url, body);
  return response;
};
